import LayoutPlan from './LayoutPlan.vue';

export default LayoutPlan;
